var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-1 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4 col-md-2  center mr-md-5 pr-5 pl-5 pt-2" },
          [
            _c("h1", { staticClass: "center widthFull" }, [
              _c("img", {
                staticClass: "img-fluid widthFull pointer linkImage",
                attrs: {
                  src: require("../../assets/images/AgenziaEntrate_logo.png")
                },
                on: {
                  click: function($event) {
                    _vm.page = "ade"
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4 col-md-2  center pt-2 ml-md-5 pr-5 pl-5 pt-3" },
          [
            _c("h1", { staticClass: "center widthFull" }, [
              _c("img", {
                staticClass: "img-fluid widthFull pointer linkImage",
                attrs: { src: require("../../assets/images/Poste.jpg") },
                on: {
                  click: function($event) {
                    _vm.page = "poste"
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "widthFull container-fluid vaillantCont mt-4 borderRed"
          },
          [
            _c("div", { staticClass: "row justify-content-center  mb-5" }, [
              _vm.page == "ade" || _vm.page == ""
                ? _c("iframe", {
                    staticStyle: {
                      border: "none",
                      width: "100%",
                      "min-height": "500px",
                      height: "70vh!important"
                    },
                    attrs: {
                      id: "contestentry",
                      src:
                        "https://telematici.agenziaentrate.gov.it/Main/login.jsp",
                      allowvr: "yes",
                      width: "100%",
                      scrolling: "yes",
                      title: "Contest Entry"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.page == "poste"
                ? _c("iframe", {
                    staticStyle: {
                      border: "none",
                      width: "100%",
                      "min-height": "500px",
                      height: "70vh!important"
                    },
                    attrs: {
                      frameborder: "0",
                      target: "_self",
                      id: "contestentry",
                      src:
                        "https://business.poste.it/professionisti-imprese/prodotti/conto-bancoposta-affari.html",
                      allowvr: "yes",
                      width: "100%",
                      allowtransparency: "true",
                      scrolling: "yes",
                      title: "Contest Entry"
                    }
                  })
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mt-3 center" }, [
      _c("h1", { staticClass: "center widthFull" }, [_vm._v(" Co-Browsing ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff98e3f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff98e3f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobrowsing/index.vue
// module id = null
// module chunks = 